import React from 'react';
import { connect } from 'react-redux';

import SignatureCanvas from 'react-signature-canvas';

import { Collapse, Button, CardBlock, Card } from 'reactstrap';

import { findModel, saveContract, validateSSN } from '../actions';

class SignupPage extends React.Component  {

    constructor(props) {
        super(props);
        this.state = {};
        this.signaturePad = React.createRef();
    }

    onSignatureSave() {
        if (this.signaturePad && this.signaturePad.current) {
            var output = this.signaturePad.current.toDataURL();
            this.signaturePad.current.off();
            this.props.onSignature(output);
        }
    }

    onSignatureClear() {
        if (this.signaturePad && this.signaturePad.current) {
            this.signaturePad.current.clear();
            this.signaturePad.current.on();
            this.props.onSignature('');
        }
    }

    render() {

        var props = this.props;

        if (!props.event && !props.status) {
            return <section className="form"><div className="container container-md">
                <div className="form-header">
                    <div className="text-center">
                        <h1>Registrering av modellavtal</h1>
                    </div>
                </div>
            </div>
            </section>;
        }

        if (props.status) {
            return <section className="form"><div className="container container-md">
                <div className="form-header">
                    <div className="text-center">
                        <h1>Registrering av modellavtal</h1>
                    </div>
                    <div className="alert alert-warning text-center">
                        Oj! Det gick inte att öppna registreringsformuläret.<br /> Har du angett rätt webbadress?
                    </div>
                </div>
            </div>
            </section>;
        }

        if (props.showStep3) {
            return <section className="form"><div className="container container-md">
                <div className="form-header">
                    <div className="text-center">
                        <img src="https://linkin.se/files/logo.svg" width="120"/>
                        <h1>Registrering av modellavtal</h1>
                    </div>
                    <div className="alert alert-success text-center">
                        Tack för din registrering!
                    </div>
                    <div className="form-text text-muted">
                        <p>Du får strax ett e-postmeddelande med en länk till din profil där dina signerade kontrakt finns samlade.</p>
                        <p>Betalning: Sker normalt den 25:e varje månad (senast nästkommande kalendermånad).</p>
                        <p>Vid frågor, skriv till oss på <a href="mailto:info@linkin.se">info@linkin.se</a>.</p>
                    </div>
                </div>

            </div></section>;
        }

        return <section className="form">
            <div className="container container-md">
                <div className="form-header">
                    <div className="text-center">
                        <img src="https://linkin.se/files/logo.svg"  alt="Linkin logotyp" width="120"/>
                        <h1>Registrering av modellavtal</h1>
                    </div>
                    <div className="form-text text-muted">
                        <p>{props.eula}</p>
                    </div>
                </div>
                {!props.showStep2 && <form>

                    <div className="form-group">
                        <label>Vem registrerar du?</label>
                        <div className="select" >
                            <select className="form-control" onChange={props.onRegisterType} value={props.registerType}>
                                <option value="1">Jag registrerar mig själv</option>
                                <option value="2">Jag registrerar en annan person som målsman</option>
                            </select>
                        </div>
                    </div>
                    {props.registerType === 2 && <div className="alert alert-info">Om du registrerar en annan person intygar du att du har rätt att företräda personen och lämna samtycke till behandlingen av dennes personuppgifter.</div>}
                    <div className="form-group">
                        <label>{props.registerType === 2 ? 'Modellens personnummer' : 'Ditt personnummer'}</label>
                        <input type="text" className="form-control" placeholder="ÅÅÅÅMMDD-XXXX" value={props.ssn}
                               onChange={props.onFieldChange.bind(null, 'ssn', 0)}/>
                    </div>
                    <div className="form-group">
                        <label>Din e-postadress</label>
                        <input type="email" className="form-control" placeholder="info@epost.se" value={props.email}
                               onChange={props.onFieldChange.bind(null, 'email', 0)}/>
                    </div>
                    {props.invalidSSNEmail && <div className="alert alert-warning">
                        Ditt personnummer eller e-postadress är felformaterat, var vänlig kontrollera dina uppgifter
                    </div>}
                    {props.invalidAge && <div className="alert alert-warning">
                        Det personnummer som angavs kräver målsmans underteckning. Välj istället att registrera en annan person.
                    </div>}
                    <div className="form-footer text-center">
                        <button type="submit" onClick={props.onGetModelClick} disabled={!props.email || !props.ssn}
                                className="btn btn-success btn-lg">Fortsätt <i className="fa-light fa-arrow-right"></i>
                        </button>
                    </div>
                </form>}
                {
                    props.showStep2 &&
                    <div>
                        <h3 className="text-center">Modelluppgifter</h3>
                        {props.models && props.models.map((model, i) => {

                            return <form>

                                <div className="form-group">
                                    <label>{props.registerType === 2 ? 'Modellens personnummer' : 'Ditt personnummer'}</label>
                                    <input type="text" className="form-control" placeholder="ÅÅÅÅMMDD-XXXX" value={props.ssn}
                                           onChange={props.onFieldChange.bind(null, 'ssn', 0)}/>
                                </div>
                                <div className="form-group">
                                    <label>{'Din e-postadress'}</label>
                                    <input type="email" className="form-control" placeholder="info@epost.se" value={props.email}
                                           onChange={props.onFieldChange.bind(null, 'email', 0)}/>
                                </div>
                                {props.registerType === 2 && <div className="alert alert-info">Ange modellens namn, adressuppgifter och beskrivning nedan.</div>}
                                <div className="form-group">
                                    <label>Namn</label>
                                    <input type="text" className="form-control" onChange={props.onFieldChange.bind(null, 'name', i)}
                                           value={ model.name }/>
                                </div>
                                <div className="form-group">
                                    <label>Gatuadress</label>
                                    <input type="text" className="form-control" onChange={props.onFieldChange.bind(null, 'address', i)}
                                           value={ model.address }/>
                                </div>
                                <div className="form-row">
                                    <div className="col-4">
                                        <div className="form-group">
                                            <label>Postnummer</label>
                                            <input type="text" className="form-control" onChange={props.onFieldChange.bind(null, 'postal_code', i)}
                                                   value={ model.postal_code }/>
                                        </div>
                                    </div>
                                    <div className="col-8">
                                        <div className="form-group">
                                            <label>Postort</label>
                                            <input type="text" className="form-control" onChange={props.onFieldChange.bind(null, 'city', i)}
                                                   value={ model.city }/>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label>Telefon</label>
                                    <input type="text" className="form-control" onChange={props.onFieldChange.bind(null, 'phone', i)}
                                           value={ model.phone }/>
                                </div>
                                <div className="form-group">
                                    <label>{props.registerType === 2 ? "Beskriv modellen" : "Beskriv dig själv"}</label>
                                    <textarea className="form-control" placeholder="Ex: 167cm lång, gillar utklädnad, ogillar höjder" onChange={props.onFieldChange.bind(null, 'description', i)}
                                              rows="3">{ model.description }</textarea>
                                </div>
                                <div className="form-group">
                                    <label>Profilbild</label>
                                    {!model.profile && <div className="form-control text-center">
                                        <hr />
                                        <label htmlFor={ 'profile-' + i } className="profile-pick btn btn-success">Välj eller ta en bild</label>
                                        <input id={ 'profile-' + i } type="file" name={ 'profile-' + i } className="profile-pick-file"  onChange={props.onPhoto.bind(null, i)} />
                                    </div>}
                                    {model.profile && <div className="form-control"><img src={model.profile} style={ { width: '100%' } } />
                                        <hr />
                                        <button onClick={props.newProfile.bind(null, i)} className="btn btn-success">Byt bild</button>
                                    </div> }
                                </div>
                            </form>

                        })}
                    </div>
                }
                {
                    props.showStep2 &&
                    <div>
                        <h3 className="text-center">{props.compensation > 0 ? 'Betalning & underskrift' : 'Underskrift'}</h3>
                        {props.compensation > 0 && <div>
                            <div className="form-group">
                                <label>Arvode</label>
                                <p className="form-control">{props.compensation} kr</p>
                            </div>
                            <div className="form-group">
                                <label>Bank</label>
                                <input type="text" className="form-control" onChange={props.onFieldChange.bind(null, 'payment_transfer_bank', -1)} value={ props.payment ? props.payment.bank : '' }/>
                            </div>
                            <div className="form-group">
                                <label>Kontonummer</label>
                                <input type="text" className="form-control" onChange={props.onFieldChange.bind(null, 'payment_transfer_account', -1)} value={ props.payment ? props.payment.account : '' }/>
                            </div>
                            <div className="form-group">
                                <label>Clearing</label>
                                <input type="text" className="form-control" onChange={props.onFieldChange.bind(null, 'payment_transfer_clearing', -1)} value={ props.payment ? props.payment.clearing : '' }/>
                            </div>
                            <hr />
                        </div>}

                        <div className="form-group">
                            <label>Plats (vid undertecknandet)</label>
                            <input type="text" className="form-control" onChange={props.onFieldChange.bind(null, 'location', -1)} value={ props.location }
                                   placeholder="ex: Linköping"/>
                        </div>
                        <div className="form-group">
                            <div className="form-control">
                                <label>{'Din underskrift'}</label>
                                <div className="signature-pad-container">
                                    <SignatureCanvas
                                        ref={this.signaturePad}
                                        onEnd={this.onSignatureSave.bind(this)}
                                        canvasProps={{ className: 'signature-canvas' }}
                                    />
                                </div>
                                <hr />
                                <div className="text-center">
                                  <button disabled={!(props.signature && props.signature.length > 1)} onClick={this.onSignatureClear.bind(this)} className="btn btn-warning">Gör om underskrift</button>
                                </div>
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="form-control form-control-terms">
                                <h3>Användarvillkor & Integritet</h3>
                                <p>När du registrerar dig själv eller registrerar en annan person (exempelvis ditt barn) sparar vi de personuppgifter som behövs för att kunna erbjuda modelluppdrag, hantera avtal samt genomföra utbetalningar. Vi behandlar endast nödvändiga uppgifter såsom kontaktuppgifter, personnummer, kontouppgifter samt bilder och material som laddas upp.</p>
                                <p>Om du registrerar en annan person intygar du att du har rätt att företräda personen och lämna samtycke till behandlingen av dennes personuppgifter.</p>
                                <p>Behandlingen sker för att uppfylla vårt avtal med dig och/eller den registrerade personen, med stöd av samtycke samt för att följa lagkrav, exempelvis bokföringslagen där vissa uppgifter måste sparas i minst sju år.</p>
                                <p>Personuppgifter delas endast med parter som behöver dem för att kunna genomföra uppdrag eller betalningar och lämnas aldrig vidare i marknadsföringssyfte.</p>
                                <p>Du kan när som helst avsluta kontot. Uppgifter kopplade till kontot sparas så länge det är aktivt. Avtal och uppgifter som omfattas av lagkrav sparas under sin giltighetstid och enligt lagstadgade regler. Du har rätt att begära registerutdrag, rättning eller radering av personuppgifter.</p>
                                <p>För frågor eller önskemål gällande personuppgifter, kontakta oss på info@linkin.se.</p>

                                <div className="switch-container">
                                  <button onClick={props.onTerms} className={"switch" + (props.terms ? " checked" : "")}>
                                    <span className="slider"></span>
                                    <span className="label">Jag godkänner villkoren</span>
                                  </button>
                                </div>
                            </div>
                         </div>
                        {props.invalid && <div className="alert alert-warning">
                            Var vänlig och kontrollera att följande fält är korrekt ifyllda:
                            <ul className="list-unstyled">
                            {props.invalidData && props.invalidData.map(data => {
                                let text = null;
                                switch (data) {
                                    case 'terms':
                                        text = 'Det krävs att du godkänner användarvillkoren'
                                        break;
                                    case 'ssn':
                                        text = 'Personnummer: Ange ett giltigt personnummer'
                                        break;
                                    case 'name':
                                        text = 'Namn: Ange ett namn'
                                        break;
                                    case 'phone':
                                        text = 'Telefon: Ange ett telefonnummer utan mellanslag'
                                        break;
                                    case 'email':
                                        text = 'E-post: Ange en giltig e-postadress'
                                        break;
                                    case 'address':
                                        text = 'Adress: Ange en adress'
                                        break;
                                    case 'postal_code':
                                        text = 'Postnummer: Ange fem siffror utan mellanslag'
                                        break;
                                    case 'city':
                                        text = 'Postort: Ange en postort'
                                        break;
                                    case 'location':
                                        text = 'Plats: Ange plats (vid undertecknandet)'
                                        break;
                                    case 'signature':
                                        text = 'Signatur: Teckna din signatur'
                                        break;
                                    case 'payment':
                                        text = 'Betalning: Ange din kompletta betalningsinformation'
                                        break;
                                    case 'image':
                                        text = 'Bild: Ogiltig profilbild, välj en annan bild'
                                        break;
	                                case 'profile':
		                                text = 'Bild: Välj en profilbild'
		                                break;

                                }
                                if (text) {
                                    return <li>{text}</li>
                                }
                            })}
                            </ul>
                        </div>}
                        {props.invalidUnknown && <div className="alert alert-danger">
                            Ett oväntat fel uppstod, om problemet kvarstår var vänlig och kontakta oss. (Felkod: {props.errorCode})
                        </div>}
                        <div className="form-footer text-center">
                            <button type="submit" className="btn btn-dark btn-lg" onClick={props.onSaveContract}>
                                Skicka <i className="fa-light fa-arrow-right"></i></button>
                        </div>
                    </div>
                }

            </div>
        </section>;
    }
}

export default connect(state => state.registerState, (dispatch) => {
    return {
        onGetModelClick: (e) => {
            findModel(dispatch);
            e.preventDefault();
        },
        onSaveContract: (e) => {
            e.preventDefault();
            saveContract(dispatch);
        },
        onSignature: (value) => {
            dispatch({
                type: 'REGISTER_FIELD_CHANGE',
                field: 'signature',
                value: value
            })
        },
        onRegisterType: (e) => {
            e.preventDefault();
            dispatch({
                type: 'REGISTER_TYPE',
                registerType: parseInt(e.target.value)
            })
        },
        onTerms: () => {
            dispatch({
                type: 'REGISTER_TERMS'
            })
        },
        onFieldChange: (field, index, e)  => {

            dispatch({
                type: 'REGISTER_FIELD_CHANGE',
                field: field,
                index: index,
                value: e.target.value
            })
        },
        newProfile: (index, e) => {
            dispatch({
                type: 'REGISTER_FIELD_CHANGE',
                field: 'profile',
                index: index,
                value: ''
            })
        },
        onPhoto: (index, e) => {
            var file = e.target.files[0];
            var reader = new FileReader();
            reader.onloadend = function() {
                var orgImage = new Image;
                orgImage.onload = () => {
                    // create an off-screen canvas
                    var canvas = document.createElement('canvas'),
                        ctx = canvas.getContext('2d');

                    var maxWidth = 600;
                    var maxHeight = 600;

                    var ratio = maxWidth / orgImage.width;
                    var newW = maxWidth;
                    var newH = orgImage.height * ratio;

                    if (newH > maxHeight) {
                        ratio = maxHeight / orgImage.height;
                        newH = maxHeight;
                        newW = orgImage.width * ratio;
                    }

                    // set its dimension to target size
                    canvas.width = newW;
                    canvas.height = newH;

                    // draw source image into the off-screen canvas:
                    ctx.drawImage(orgImage, 0, 0, newW, newH);

                    // encode image to data-uri with base64 version of compressed image
                    var image = canvas.toDataURL('image/jpeg', 0.8);

                    dispatch({
                        type: 'REGISTER_FIELD_CHANGE',
                        field: 'profile',
                        index: index,
                        value: image
                    })
                };
                orgImage.src = reader.result;


            }
            reader.readAsDataURL(file);
        }
    }
})(SignupPage);
